import { render } from "./LogEdit.vue?vue&type=template&id=39dec8ed"
import script from "./LogEdit.vue?vue&type=script&lang=js"
export * from "./LogEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__